import s from './Account.module.css';
import BuyButton from "../../assets/Components/StyledComponents/BuyButton";
import {getAuth, createUserWithEmailAndPassword} from "firebase/auth";
import React, {useState} from "react";
import {setUserInfo} from "../../firebase";
import {Navigate} from "react-router-dom";
import {useSelector} from "react-redux";

const Registration = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [name, setName] = useState("");
    const [surname, setSurname] = useState("");
    const [phone, setPhone] = useState("");
    const [country, setCountry] = useState("");
    const [region, setRegion] = useState("");
    const [city, setCity] = useState("");
    const [address, setAddress] = useState("");
    const [formError, setFormError] = useState(null);
    const [isRegistred, setIsRegistred] = useState(false);


    const handleSubmit = (e, email, password) => {
        e.preventDefault();
        const auth = getAuth();
        if (password !== confirmPassword) {
            setFormError("Пароли не совпадают");
            return;
        }
        createUserWithEmailAndPassword(auth, email, password)
            .then(({user}) => {
                setFormError(null);
                setIsRegistred(true);
                setUserInfo(user.uid, {name, email, surname, phone, country, region, city, address});
            })
            .catch((error) => {
                setFormError(error.message);
            });
    }

    return (
        <div className={s.registration}>
            {isRegistred ? <Navigate to="/account/success"/> : null}
            <h3>Регистрация</h3>
            <p>Если Вы уже зарегистрированы, перейдите на страницу авторизации.</p>
            <form onSubmit={(e) => handleSubmit(e, email, password)}>
                <div>
                    <h5>Ваше имя:</h5>
                    <input value={name} onChange={(e) => setName(e.target.value)} type="text"/>
                </div>
                <div>
                    <h5>Ваша фамилия:</h5>
                    <input value={surname} onChange={(e) => setSurname(e.target.value)} type="text"/>
                </div>
                <div>
                    <h5>E-mail:</h5>
                    <input value={email} onChange={(e) => setEmail(e.target.value)} type="email"/>
                </div>
                <div>
                    <h5>Телефон:</h5>
                    <input value={phone} onChange={(e) => setPhone(e.target.value)} type="tel"/>
                </div>
                <div>
                    <h5>Страна:</h5>
                    <input value={country} onChange={(e) => setCountry(e.target.value)} type="text"/>
                </div>
                <div>
                    <h5>Область:</h5>
                    <input value={region} onChange={(e) => setRegion(e.target.value)} type="text"/>
                </div>
                <div>
                    <h5>Город:</h5>
                    <input value={city} onChange={(e) => setCity(e.target.value)} type="text"/>
                </div>
                <div>
                    <h5>Адрес:</h5>
                    <input value={address} onChange={(e) => setAddress(e.target.value)} type="text"/>
                </div>
                <div>
                    <h5>Пароль:</h5>
                    <input value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="off"
                           type="password"/>
                </div>
                <div>
                    <h5>Подтвердите пароль:</h5>
                    <input value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)}
                           autoComplete="off" type="password"/>
                </div>
                <div>
                    {formError ? <p>Ошибка: {formError}</p> : null}
                    <BuyButton type="submit">ПРОДОЛЖИТЬ</BuyButton>
                </div>
            </form>
        </div>

    )
}


export default Registration;